if (jQuery('#newsletter-form').length !== 0) {

    jQuery(function ($) {
        var body = $('body'),
            $emailError = $('#email-error'),
            $tickSymbol = $('#tickSymbol'),
            $emailInput = $('[name="email"]', body),
            $alreadyUserINSendGrid = $('#alreadyUserINSendGrid');

        function doSubmit(ev) {

            trackCTA('newsletter_click_submit');
            if (ev && ev.preventDefault) ev.preventDefault();

            var form = $(this),
                $emailInputForm = $('[name="email"]', form),
                data = {
                    action: 'tct_insert_subscribe_contact_to_DB',
                    mail: $emailInputForm.val()
                    // firstName: $('[name="firstName"]', form).val(),
                    // lastName: $('[name="lastName"]', form).val()
                };

            if (!isEmail(data.mail)) {
                $emailError.text("Please enter a valid email address.");
                $emailError.addClass("errorText");
                $emailInputForm.addClass("error-text-box");
                return false;
            }
            else {
                $emailError.text("");
                $emailError.removeClass("errorText");
                $emailInputForm.removeClass("error-text-box");
            }


            // make AJAX call
            $.post(window['TCTServer']['ajax_url'], data, "json")
                .success(function (response) {

                    if (response.inserted) {
                        trackConversion('newsletter_new_subscribe');
                        $alreadyUserINSendGrid.css('visibility', 'hidden');
                        $('#newsletter-form').hide();
                        $('#newsletter-div').append('<h3 style="padding-top: 5px">Thank you very much! You are now signed up.</h3>');
                    }
                    else {
                        $alreadyUserINSendGrid.css('visibility', 'visible');

                    }

                })
                .error(function (response) {
                    console.debug('page-newsletter.php - data:', response);
                })
                .complete(function () {
                });

            return false;

        }

        body.on('submit', '#newsletter-form', doSubmit);


        function isEmail(email) {
            var regex = /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i;
            ;
            return regex.test(email);
        }


        $emailInput.keyup(function (e) {


            if (!isEmail($('[name="email"]', body).val())) {
                $emailInput.addClass("error-text-box");
                $emailInput.removeClass("success-text-box");
                $tickSymbol.html("");
            }
            else {
                $emailError.html("");
                $emailInput.removeClass("error-text-box");
                $emailInput.addClass("success-text-box");
                $tickSymbol.html("&#10003");
            }
        });

        $emailInput.focus(function () {
            $alreadyUserINSendGrid.css('visibility', 'hidden');
        });
        $emailInput.focusout(function () {
            if (!isEmail($('[name="email"]', body).val())) {
                $emailError.text("Please enter a valid email address.");
                $emailError.addClass("errorText");
                $emailInput.addClass("error-text-box");
                $emailInput.removeClass("success-text-box");
                $tickSymbol.html("");
            }
            else {
                $emailError.text("");
                $emailError.removeClass("errorText");
                $emailInput.removeClass("error-text-box");
                $emailInput.addClass("success-text-box");
                $tickSymbol.html("&#10003");
            }
        });
        setTimeout(function () {
            $("#newsletter-sign-up #newsletter-div").one('inview', function () {
                trackCTA('newsletter_form_show');
            });
        }, 1000);


    });
}
